import { PlotReportFactElement } from '@/api/rest/resources/types/fact';

export const MEDIA_MAP_FACT_PREFIX = 'insitu_media_map_fact_';

export type MediaMapFact = {
  plot_name: string;
  indicator_name: string;
  unit: null;
  value: string;
  reference_date: string;
  label_longitude: number;
  label_latitude: number;
  label_species: string | null;
  label_common_name: string | null;
  label_description: string | null;
  label_mode_of_sight: string | null;
  label_time_of_sight: string | null;
  label_credits: string | null;
  label_url: string | null;
};

export type MediaMapDraftItem = MediaMapFact & {
  id: string;
};

export const buildIndicatorName = (configurationId: string) => `${MEDIA_MAP_FACT_PREFIX}${configurationId}`;

export const buildMediaMapJsonFile = (items: MediaMapDraftItem[]): File => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const json = JSON.stringify(items.map(({ id, ...rest }) => rest));
  return new File([json], 'media-map.json', { type: 'application/json' });
};

export const createDraftItemId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

export const factToDraftItem = (
  plotName: string,
  fact: PlotReportFactElement<string>,
  configurationId: string,
): MediaMapDraftItem => {
  const labels = fact.labels ?? [];
  const getLabel = (name: string) => labels.find((l) => l.name === name)?.value as string | null | undefined;

  return {
    id: createDraftItemId(),
    plot_name: plotName,
    indicator_name: buildIndicatorName(configurationId),
    unit: null,
    value: fact.value,
    reference_date: fact.date ?? '',
    label_longitude: Number(getLabel('longitude') ?? 0),
    label_latitude: Number(getLabel('latitude') ?? 0),
    label_species: getLabel('species') ?? null,
    label_common_name: getLabel('common_name') ?? null,
    label_description: getLabel('description') ?? null,
    label_mode_of_sight: getLabel('mode_of_sight') ?? null,
    label_time_of_sight: getLabel('time_of_sight') ?? null,
    label_credits: getLabel('credits') ?? null,
    label_url: getLabel('url') ?? null,
  };
};
